// internationalization
import { useTranslation } from 'react-i18next';

// shared components
import {
  type DateRangePreset,
  getDefaultPresets,
} from '@/components/ui/datetime/dateRangePresets';

import { DateTime } from 'luxon';

const ESG_PRESET_KEYS = ['ytd', 'previous_year'];

const yearBeforeLast: DateRangePreset = (() => {
  const year = DateTime.now().minus({ years: 2 });
  return {
    key: 'year_before_last',
    label: String(year.year),
    getRange: () => ({ from: year.startOf('year'), to: year.endOf('year') }),
  };
})();

export const useEsgRangePresets = (): DateRangePreset[] => {
  const { t } = useTranslation('view-data');
  const base = getDefaultPresets(t).filter((preset) =>
    ESG_PRESET_KEYS.includes(preset.key),
  );

  const last12Months: DateRangePreset = {
    key: 'last_12_months',
    label: t('range_presets.last_12_months'),
    getRange: () => {
      const now = DateTime.now();
      return { from: now.minus({ months: 12 }), to: now };
    },
  };

  return [...base, yearBeforeLast, last12Months];
};
